import React from 'react';

import {
  After, Life, LifeSaver 
} from './';

export function AfterLife() {
  return <LifeSaver />;
  return (
    <div className="after-life">
      <After />
      <Life />
    </div>
  );
}
